import { render, staticRenderFns } from "./OpportunityContact.vue?vue&type=template&id=1e5d4800&scoped=true"
import script from "./OpportunityContact.vue?vue&type=script&lang=js"
export * from "./OpportunityContact.vue?vue&type=script&lang=js"
import style0 from "./OpportunityContact.vue?vue&type=style&index=0&id=1e5d4800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5d4800",
  null
  
)

export default component.exports